import fetcher, { STATUS_OK } from "../../libs/fetcher";
import { IIndexParamsAssetsBaseLine, IIndexResponseAssetsBaseLine } from "../../models/AssetBaseLine";

export const indexAssetsBaseLines = async ({ package_id }: IIndexParamsAssetsBaseLine): Promise<IIndexResponseAssetsBaseLine> => {
    const url = `/packages/${package_id}/assets_base_lines`;
    let response: IIndexResponseAssetsBaseLine = { data: [], totalItems: 0 };
    try {
        const fetchResponse = await fetcher({
            url: `${url}`,
            method: 'GET'
        });
        if (fetchResponse === undefined) {
            throw new Error('Request failed');
        }
        const { fetch } = fetchResponse;
        
        // console.log("🚀 ~ indexAssetsBaseLines ~ fetch:", fetch)

        if (typeof fetch === 'string') {
            throw "Error al recibir la respuesta";
        } else if (fetch instanceof Object) {
            if ('status' in fetch && fetch.status === STATUS_OK) {
                const responseData = 'data' in fetch ? fetch.data : null;
                if (Array.isArray(responseData.data)) {
                    response.data = responseData.data;
                    response.totalItems = responseData.totalItems;
                }
            }
        }

        return response;

    } catch (error) {
        return response;
    }
}